/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EdgedCredentialDetailedDto,
  GetAliasesRequest,
  GetAliasesResponse,
  GetListRequest,
  GetListResponse,
  RelatedDossierResponse,
  RelatedToTnCredsDto,
  TnCredsRelatedToTnDto,
  WatcherCredDto,
} from '../models/index';
import {
    EdgedCredentialDetailedDtoFromJSON,
    EdgedCredentialDetailedDtoToJSON,
    GetAliasesRequestFromJSON,
    GetAliasesRequestToJSON,
    GetAliasesResponseFromJSON,
    GetAliasesResponseToJSON,
    GetListRequestFromJSON,
    GetListRequestToJSON,
    GetListResponseFromJSON,
    GetListResponseToJSON,
    RelatedDossierResponseFromJSON,
    RelatedDossierResponseToJSON,
    RelatedToTnCredsDtoFromJSON,
    RelatedToTnCredsDtoToJSON,
    TnCredsRelatedToTnDtoFromJSON,
    TnCredsRelatedToTnDtoToJSON,
    WatcherCredDtoFromJSON,
    WatcherCredDtoToJSON,
} from '../models/index';

export interface AutomationRevocationRequest {
    saidQuery: string;
    userId?: string;
}

export interface GetAliasesOperationRequest {
    getAliasesRequest: GetAliasesRequest;
}

export interface GetBySaidRequest {
    said: string;
}

export interface GetEdgedCredentialDetailsRequest {
    said: string;
}

export interface GetListOperationRequest {
    getListRequest: GetListRequest;
    withAidInfo?: boolean;
}

export interface RelatedDossierRequest {
    said: string;
}

export interface RelatedDossierByQueryRequest {
    saidQuery: string;
}

export interface RelatedToTnCredsRequest {
    phoneNumber: string;
}

export interface RevocationRequest {
    saidQuery: string;
}

export interface SaveCredRequest {
    watcherCredDto: WatcherCredDto;
}

export interface TnCredsRelatedToTnCredsRequest {
    phoneNumber: string;
}

/**
 * 
 */
export class WatcherCredControllerApi extends runtime.BaseAPI {

    /**
     * Revoke credential
     */
    async automationRevocationRaw(requestParameters: AutomationRevocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WatcherCredDto>> {
        if (requestParameters['saidQuery'] == null) {
            throw new runtime.RequiredError(
                'saidQuery',
                'Required parameter "saidQuery" was null or undefined when calling automationRevocation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        if (requestParameters['saidQuery'] != null) {
            queryParameters['said-query'] = requestParameters['saidQuery'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/agent/watcher/cred/automation-revocation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WatcherCredDtoFromJSON(jsonValue));
    }

    /**
     * Revoke credential
     */
    async automationRevocation(requestParameters: AutomationRevocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WatcherCredDto> {
        const response = await this.automationRevocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get several credential aliases by saids
     */
    async getAliasesRaw(requestParameters: GetAliasesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAliasesResponse>> {
        if (requestParameters['getAliasesRequest'] == null) {
            throw new runtime.RequiredError(
                'getAliasesRequest',
                'Required parameter "getAliasesRequest" was null or undefined when calling getAliases().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/agent/watcher/cred/aliases`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetAliasesRequestToJSON(requestParameters['getAliasesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAliasesResponseFromJSON(jsonValue));
    }

    /**
     * Get several credential aliases by saids
     */
    async getAliases(requestParameters: GetAliasesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAliasesResponse> {
        const response = await this.getAliasesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get credential by said
     */
    async getBySaidRaw(requestParameters: GetBySaidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WatcherCredDto>> {
        if (requestParameters['said'] == null) {
            throw new runtime.RequiredError(
                'said',
                'Required parameter "said" was null or undefined when calling getBySaid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/agent/watcher/cred/{said}`.replace(`{${"said"}}`, encodeURIComponent(String(requestParameters['said']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WatcherCredDtoFromJSON(jsonValue));
    }

    /**
     * Get credential by said
     */
    async getBySaid(requestParameters: GetBySaidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WatcherCredDto | null | undefined > {
        const response = await this.getBySaidRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Get credentials details with edged chain elements
     */
    async getEdgedCredentialDetailsRaw(requestParameters: GetEdgedCredentialDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EdgedCredentialDetailedDto>> {
        if (requestParameters['said'] == null) {
            throw new runtime.RequiredError(
                'said',
                'Required parameter "said" was null or undefined when calling getEdgedCredentialDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/agent/watcher/cred/edged/{said}`.replace(`{${"said"}}`, encodeURIComponent(String(requestParameters['said']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EdgedCredentialDetailedDtoFromJSON(jsonValue));
    }

    /**
     * Get credentials details with edged chain elements
     */
    async getEdgedCredentialDetails(requestParameters: GetEdgedCredentialDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EdgedCredentialDetailedDto | null | undefined > {
        const response = await this.getEdgedCredentialDetailsRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Get credentials parameters for list by said
     */
    async getListRaw(requestParameters: GetListOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetListResponse>>> {
        if (requestParameters['getListRequest'] == null) {
            throw new runtime.RequiredError(
                'getListRequest',
                'Required parameter "getListRequest" was null or undefined when calling getList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['withAidInfo'] != null) {
            queryParameters['withAidInfo'] = requestParameters['withAidInfo'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/agent/watcher/cred/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetListRequestToJSON(requestParameters['getListRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetListResponseFromJSON));
    }

    /**
     * Get credentials parameters for list by said
     */
    async getList(requestParameters: GetListOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetListResponse> | null | undefined > {
        const response = await this.getListRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Find last active dossier by related credential said. For example, can be used to find dossier credential by used TN credential
     */
    async relatedDossierRaw(requestParameters: RelatedDossierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelatedDossierResponse>> {
        if (requestParameters['said'] == null) {
            throw new runtime.RequiredError(
                'said',
                'Required parameter "said" was null or undefined when calling relatedDossier().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/agent/watcher/cred/related-dossier/{said}`.replace(`{${"said"}}`, encodeURIComponent(String(requestParameters['said']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RelatedDossierResponseFromJSON(jsonValue));
    }

    /**
     * Find last active dossier by related credential said. For example, can be used to find dossier credential by used TN credential
     */
    async relatedDossier(requestParameters: RelatedDossierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelatedDossierResponse> {
        const response = await this.relatedDossierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Required for DF-2797
     */
    async relatedDossierByQueryRaw(requestParameters: RelatedDossierByQueryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelatedDossierResponse>> {
        if (requestParameters['saidQuery'] == null) {
            throw new runtime.RequiredError(
                'saidQuery',
                'Required parameter "saidQuery" was null or undefined when calling relatedDossierByQuery().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['saidQuery'] != null) {
            queryParameters['said-query'] = requestParameters['saidQuery'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/agent/watcher/cred/related-dossier`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RelatedDossierResponseFromJSON(jsonValue));
    }

    /**
     * Required for DF-2797
     */
    async relatedDossierByQuery(requestParameters: RelatedDossierByQueryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelatedDossierResponse> {
        const response = await this.relatedDossierByQueryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find last active dossier and other related credentials by specified TN number
     */
    async relatedToTnCredsRaw(requestParameters: RelatedToTnCredsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelatedDossierResponse>> {
        if (requestParameters['phoneNumber'] == null) {
            throw new runtime.RequiredError(
                'phoneNumber',
                'Required parameter "phoneNumber" was null or undefined when calling relatedToTnCreds().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/agent/watcher/cred/related-tn-creds/{phone_number}`.replace(`{${"phone_number"}}`, encodeURIComponent(String(requestParameters['phoneNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RelatedDossierResponseFromJSON(jsonValue));
    }

    /**
     * Find last active dossier and other related credentials by specified TN number
     */
    async relatedToTnCreds(requestParameters: RelatedToTnCredsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelatedDossierResponse> {
        const response = await this.relatedToTnCredsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Revoke credential
     */
    async revocationRaw(requestParameters: RevocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WatcherCredDto>> {
        if (requestParameters['saidQuery'] == null) {
            throw new runtime.RequiredError(
                'saidQuery',
                'Required parameter "saidQuery" was null or undefined when calling revocation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['saidQuery'] != null) {
            queryParameters['said-query'] = requestParameters['saidQuery'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/agent/watcher/cred/revocation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WatcherCredDtoFromJSON(jsonValue));
    }

    /**
     * Revoke credential
     */
    async revocation(requestParameters: RevocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WatcherCredDto> {
        const response = await this.revocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save AID to watcher schema if it is not present in DB
     */
    async saveCredRaw(requestParameters: SaveCredRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WatcherCredDto>> {
        if (requestParameters['watcherCredDto'] == null) {
            throw new runtime.RequiredError(
                'watcherCredDto',
                'Required parameter "watcherCredDto" was null or undefined when calling saveCred().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/agent/watcher/cred/new`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WatcherCredDtoToJSON(requestParameters['watcherCredDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WatcherCredDtoFromJSON(jsonValue));
    }

    /**
     * Save AID to watcher schema if it is not present in DB
     */
    async saveCred(requestParameters: SaveCredRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WatcherCredDto> {
        const response = await this.saveCredRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find last active TN credential by specified TN number
     */
    async tnCredsRelatedToTnCredsRaw(requestParameters: TnCredsRelatedToTnCredsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TnCredsRelatedToTnDto>> {
        if (requestParameters['phoneNumber'] == null) {
            throw new runtime.RequiredError(
                'phoneNumber',
                'Required parameter "phoneNumber" was null or undefined when calling tnCredsRelatedToTnCreds().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/agent/watcher/cred/tn-cred-related-to/{phone_number}`.replace(`{${"phone_number"}}`, encodeURIComponent(String(requestParameters['phoneNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TnCredsRelatedToTnDtoFromJSON(jsonValue));
    }

    /**
     * Find last active TN credential by specified TN number
     */
    async tnCredsRelatedToTnCreds(requestParameters: TnCredsRelatedToTnCredsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TnCredsRelatedToTnDto> {
        const response = await this.tnCredsRelatedToTnCredsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
